module.exports = __webpack_public_path__ + "img/eflexLogo.43be27ec.png";